import React from 'react';
import { Link } from 'react-router-dom';
import { useSellerShop } from '../hooks/useSellerShops';
import SaveSellerButton from './SaveSellerButton';
import Icon from './Icon';

export default function SellerShopCard({ sellerId, fallbackName, storefront = false }) {
  const query = useSellerShop(sellerId);
  const shop = query.data;
  if (!Number.isSafeInteger(Number(sellerId)) || Number(sellerId) <= 0) return null;
  const name = shop?.name || fallbackName || 'Продавец MaxMarket';
  const Heading = storefront ? 'h1' : 'h2';
  const url = `/shop/${sellerId}`;

  return <section className="seller-shop-card" aria-label={storefront ? 'Витрина продавца' : 'Информация о продавце'}>
    <div className="seller-shop-identity">
      <div className="seller-shop-avatar"><Icon name="bag" size={24} /></div>
      <div>
        <span className="seller-shop-kicker">Магазин</span>
        <Heading>{storefront ? name : <Link to={url}>{name}</Link>}</Heading>
      </div>
    </div>
    {shop ? <div className="seller-shop-metrics">
      <span><span aria-hidden="true">★ </span>{shop.rating == null ? 'Пока нет оценок' : <><strong>{shop.rating.toLocaleString('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}</strong> · {shop.ratingCount.toLocaleString('ru-RU')} оценок</>}</span>
      <span><strong>{shop.soldCount.toLocaleString('ru-RU')}</strong> продано</span>
    </div> : <p className="seller-shop-kicker" role="status">{query.isError ? 'Статистика пока недоступна' : 'Загружаем статистику…'}</p>}
    <div className="seller-shop-actions">
      <SaveSellerButton sellerId={sellerId} />
      {!storefront && <Link className="btn btn-primary" to={url}>Все товары продавца <Icon name="arrow" size={16} /></Link>}
    </div>
  </section>;
}
